import AbstractInput from './AbstractInput';

enum MobilePhoneError { empty, format }

export default class MobilePhone extends AbstractInput<string, MobilePhoneError> {
  REGEX = /^3[0-9]{2}[ -]?[0-9]{7}$/;

  empty = () => {
    return this.value === null || this.value === undefined || this.value.trim() === '';
  };

  errorMessage = () => {
    const displayError = this.validator();

    if (displayError === MobilePhoneError.empty) return 'El campo celular es requerido';
    if (displayError === MobilePhoneError.format) return 'Celular no tiene formato correcto';
    return null;
  };

  validator = () => {
    if(!this.allowEmpty) {
      if (this.empty()) return MobilePhoneError.empty;
    }
    if (this.empty()) return null;

    if (!this.REGEX.test(this.value)) return MobilePhoneError.format;

    return null;
  };
}